import Grid from '@mui/material/Grid';
import DataField from '../../atoms/dataField';
import React, { FC, useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import { CONNECTION_TYPES } from '../../../constants/_pickerValues';
import { IFormField } from '../../shared/globalTypes';
import { FormControlLabel, FormLabel, Radio, RadioGroup, SelectChangeEvent } from '@mui/material';


interface Props {
	selectedConnection: string,
	onChange: React.ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement>,
	onDropdownChange: (e: SelectChangeEvent<string>) => void,
	accountName: IFormField,
	container: IFormField,
	pathPrefix: IFormField,
	sasToken: IFormField,
	accountKey: IFormField,
}

const ConnectionAzure: FC<Props> = ({ selectedConnection, onChange, accountName, container, pathPrefix, sasToken, accountKey }: Props) => {

	const [visible, setVisible] = useState(false);
	const [showAccessType, setShowAccessType] = useState("accountKey");

	useEffect(() => {
		(selectedConnection === CONNECTION_TYPES.azure) ? setVisible(true) : setVisible(false);

	}, [selectedConnection]);

	const handleChangeAccessType = (event: React.ChangeEvent<HTMLInputElement>) => {

		setShowAccessType(event.target.value);

		if (event.target.value === 'sasToken') {
			sasToken.fieldValue = '';
			sasToken.isError = false;
		}
		else {
			accountKey.fieldValue = '';
			accountKey.isError = false;
		}

	}




	if (visible) {
		return (
			<Box sx={{ border: 1, borderColor: 'divider', padding: 3, width: '100%' }}>
				<h2>Azure Data Lake Storage</h2>
				<Grid container spacing={4}>
					<Grid item xs={5}>
						<DataField id="633e14f9-b4e5-4573-8b49-8ccc65f0919f"
							label='Account Name'
							name='accountName'
							type='text'
							required={true}
							onChange={onChange}
							value={accountName.fieldValue}
							error={accountName.isError}
						/>
					</Grid>
					<Grid item xs={5}>
						<DataField id="7189066e-95f7-441f-adde-263a2a7e883e"
							label='Container'
							name='container'
							type='text'
							required={true}
							onChange={onChange}
							value={container.fieldValue}
							error={container.isError}
						/>
					</Grid>
					<Grid item xs={2}>
						<DataField id="8f36680d-c80c-4269-9e6d-d786beb63ffe"
							label='Path Prefix'
							name='pathPrefix'
							type='text'
							required={false}
							onChange={onChange}
							value={pathPrefix.fieldValue}
							error={pathPrefix.isError}
						/>
					</Grid>
					<Grid item xs={3}>
						<FormLabel id="accessTypeLabel">Access Type</FormLabel>
						<RadioGroup
							row
							aria-labelledby="accessTypeLabel"
							defaultValue="accountKey"
							name="accessType"
							onChange={handleChangeAccessType}>
							<FormControlLabel value="sasToken" control={<Radio />} label="SAS Token" />
							<FormControlLabel value="accountKey" control={<Radio />} label="Account Key" />
						</RadioGroup>
					</Grid>
					<Grid item xs={9}>
						{showAccessType === 'sasToken' && <DataField id="b4620746-5d24-4ec4-81ee-67ce2cc98063"
							label='SAS Token'
							name='sasToken'
							type='password'
							required={true}
							onChange={onChange}
							value={sasToken.fieldValue}
							error={sasToken.isError}
						/>}
						{showAccessType === 'accountKey' && <DataField id="9284ac68-e354-475b-a0a3-2c25cf22b72a"
							label='Account Key'
							name='accountKey'
							type='password'
							required={true}
							onChange={onChange}
							value={accountKey.fieldValue}
							error={accountKey.isError}
						/>}
					</Grid>
				</Grid>
			</Box>
		)
	} else {
		return <></>
	}

};

export default ConnectionAzure;